import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Turma } from './turma';

@Injectable({ providedIn: 'root' })
export class TurmaUsuarioService {
  private readonly apiUrl = `${environment.api}/turmas-usuario`;

  constructor(private http: HttpClient) {}

  minhasTurmas(): Observable<Turma[]> {
    return this.http.get<Turma[]>(`${this.apiUrl}/minhas`);
  }
}
